import React, { createContext, useContext, useMemo, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => sessionStorage.getItem("auth_token"));

  const value = useMemo(
    () => ({
      token,
      isAuthenticated: !!token,
      setToken: (t) => {
        setToken(t);
        if (t) sessionStorage.setItem("auth_token", t);
        else sessionStorage.removeItem("auth_token");
      },
      logout: () => {
        setToken(null);
        sessionStorage.removeItem("auth_token");
      },
    }),
    [token]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
